import styled, { css } from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

import type { PageLayoutProps } from './types'

export const RIGHT_CONTENT_WIDTH = 280
export const CONTENT_GAP = 40

export const Container = styled.div<{ $size: NonNullable<PageLayoutProps['size']> }>(
  ({ $size }) => css`
    display: flex;
    flex-direction: column;

    margin-left: auto;
    margin-right: auto;

    ${$size === 'tiny' &&
    css`
      max-width: 600px;
    `};

    ${$size === 'small' &&
    css`
      max-width: 776px;
    `};

    ${$size === 'regular' &&
    css`
      max-width: 850px;
    `};

    ${$size === 'medium' &&
    css`
      max-width: 888px;
    `};

    ${$size === 'large' &&
    css`
      max-width: 888px;

      ${mediaQueries.desktop} {
        max-width: 1200px;
      }
    `};

    ${$size === 'full' &&
    css`
      max-width: 100%;
    `};
  `,
)

export const LeftContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const RightContent = styled.div`
  flex: 1;
  margin-top: 56px;

  ${mediaQueries.laptop} {
    flex: 0 1 ${RIGHT_CONTENT_WIDTH}px;

    width: ${RIGHT_CONTENT_WIDTH}px;
    margin-top: 0;
    margin-left: ${CONTENT_GAP}px;
  }
`

export const BottomContent = styled.div<{
  $margin: NonNullable<PageLayoutProps['bottomContentMargin']>
}>(
  ({ $margin }) => css`
    ${$margin === 'large' &&
    css`
      margin-top: 56px;
    `}

    ${$margin === 'medium' &&
    css`
      margin-top: 28px;
    `}

    ${$margin === 'small' &&
    css`
      margin-top: 14px;
    `}
  `,
)

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.laptop} {
    flex-direction: row;
  }
`
